import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { loyaltyService } from '../services/api';

// ─── Catalogue de partenaires fidélité — géré par l'admin (LoyaltyView.jsx),
// affiché en lecture seule côté client (AbonnementsSection.jsx). Vraie base
// Postgres (voir server/loyalty.js/schema.sql), plus en localStorage — avant,
// ce catalogue ne vivait que dans le navigateur de la personne qui l'avait
// modifié, jamais partagé entre admin et clients sur des appareils différents.

const LoyaltyCtx = createContext(null);

export function LoyaltyProvider({ children }) {
  const [partners, setPartners] = useState([]);

  const refresh = useCallback(() => {
    return loyaltyService.list().then((r) => setPartners(r.data.partners || [])).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const addPartner = useCallback(async (partner) => {
    const res = await loyaltyService.addPartner(partner);
    setPartners((prev) => [res.data.partner, ...prev]);
    return res.data.partner;
  }, []);

  const updatePartner = useCallback(async (id, updates) => {
    const res = await loyaltyService.updatePartner(id, updates);
    setPartners((prev) => prev.map((p) => (p.id === id ? res.data.partner : p)));
    return res.data.partner;
  }, []);

  const deletePartner = useCallback(async (id) => {
    await loyaltyService.deletePartner(id);
    setPartners((prev) => prev.filter((p) => p.id !== id));
  }, []);

  return (
    <LoyaltyCtx.Provider value={{ partners, addPartner, updatePartner, deletePartner }}>
      {children}
    </LoyaltyCtx.Provider>
  );
}

export const useLoyalty = () => {
  const ctx = useContext(LoyaltyCtx);
  if (!ctx) throw new Error('useLoyalty must be used within a LoyaltyProvider');
  return ctx;
};
